import { useMemo } from 'react';
import { useAppSelector } from '@/shared/model';
import type { PresetViewType } from '../api/types';
import { filterPresetsByViewType } from '../libs/filterPresetsByViewType';
import { selectPresets } from './slice';
import type { SavedPresetRecord } from './types';

type Validator<T> = (
  v: unknown,
) => { success: true; data: T } | { success: false; error: unknown };

export function usePresetsForViewType<T>(
  viewType: PresetViewType,
  validator: Validator<T>,
): SavedPresetRecord<T>[] {
  const allPresets = useAppSelector(selectPresets);
  return useMemo(
    () => filterPresetsByViewType(allPresets, viewType, validator),
    [allPresets, viewType, validator],
  );
}
